module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validationResult && _vm.validationResult.messages && _vm.validationResult.messages.length > 0),
      expression: "validationResult && validationResult.messages && validationResult.messages.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.validationResult.messages), function(message) {
    return _c('li', {
      key: message
    }, [_vm._v(_vm._s(message))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e564d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValidationResultDisplay.vue
// module id = 941
// module chunks = 1